// Module optionnel « Est-ce que je te connais vraiment ? » (inspiré de Gottman). Bilingue FR/ES.
// Pour chaque question : chacun devine pour l'autre (guess) puis répond pour soi (reality).
// Score de curiosité : ✓=2, ~=1, !=0 par question ; total /102 par personne (51 questions).

const P = (fr, es) => ({ fr, es });

export const CONNAIS_PARTS = [
  {
    id: "p1",
    title: P("Partie 1 — Mon monde intérieur", "Parte 1 — Mi mundo interior"),
    questions: [
      { n: 1, q: P("Quelle est actuellement ma principale source de stress ?", "¿Cuál es actualmente mi principal fuente de estrés?") },
      { n: 2, q: P("Quelle est actuellement la chose qui me préoccupe le plus ?", "¿Qué es lo que más me preocupa actualmente?") },
      { n: 3, q: P("Qu'est-ce qui me fait actuellement le plus plaisir ?", "¿Qué es lo que más me alegra actualmente?") },
      { n: 4, q: P("Qu'est-ce qui me fatigue ou m'épuise le plus en ce moment ?", "¿Qué me cansa o me agota más en este momento?") },
      { n: 5, q: P("Qu'est-ce qui me donne actuellement le plus d'énergie ?", "¿Qué me da actualmente más energía?") },
      { n: 6, q: P("Qu'est-ce que je voudrais davantage dans ma vie actuellement ?", "¿Qué me gustaría tener más en mi vida actualmente?") },
    ],
  },
  {
    id: "p2",
    title: P("Partie 2 — Ce qui me fait du bien", "Parte 2 — Lo que me hace bien"),
    note: P("« Est-ce que tu connais mes petites préférences ? »", "«¿Conoces mis pequeñas preferencias?»"),
    questions: [
      {
        n: 7, type: "choice",
        q: P("Lorsque j'ai eu une mauvaise journée, qu'est-ce qui me ferait le plus de bien ?", "Cuando he tenido un mal día, ¿qué me haría más bien?"),
        options: P(
          ["parler", "être écouté(e)", "être pris(e) dans les bras", "être laissé(e) tranquille", "recevoir de l'aide", "faire quelque chose ensemble", "recevoir une attention", "être rassuré(e)", "autre"],
          ["hablar", "ser escuchado/a", "que me abracen", "que me dejen tranquilo/a", "recibir ayuda", "hacer algo juntos", "recibir un detalle", "que me tranquilicen", "otro"]
        ),
      },
      { n: 8, q: P("Quel est le petit geste du quotidien qui me fait particulièrement plaisir ?", "¿Cuál es el pequeño gesto cotidiano que más me gusta?") },
      { n: 9, q: P("Quel est le moment de la journée où j'aime particulièrement avoir un moment avec toi ?", "¿En qué momento del día me gusta especialmente estar contigo?") },
      { n: 10, q: P("Quelle activité simple pourrais-tu me proposer pour me faire plaisir ?", "¿Qué actividad sencilla podrías proponerme para darme gusto?") },
      { n: 11, q: P("Quelle chose banale que nous faisons ensemble est en réalité importante pour moi ?", "¿Qué cosa banal que hacemos juntos es en realidad importante para mí?") },
    ],
  },
  {
    id: "p3",
    title: P("Partie 3 — Mes réussites, mes fiertés, mes rêves", "Parte 3 — Mis logros, mis orgullos, mis sueños"),
    note: P("Ce que Gottman appelle l'intérêt porté aux rêves, aspirations et objectifs personnels.", "Lo que Gottman llama el interés por los sueños, aspiraciones y objetivos personales."),
    questions: [
      { n: 12, q: P("De quoi suis-je le/la plus fier/fière dans notre histoire ?", "¿De qué estoy más orgulloso/a en nuestra historia?") },
      { n: 13, q: P("Quelle réussite personnelle compte particulièrement pour moi ?", "¿Qué logro personal es especialmente importante para mí?") },
      { n: 14, q: P("Quel projet me tient actuellement le plus à cœur ?", "¿Qué proyecto me importa más actualmente?") },
      { n: 15, q: P("Quel rêve personnel aimerais-je réaliser ?", "¿Qué sueño personal me gustaría realizar?") },
      { n: 16, q: P("Quel rêve ou projet aimerais-je que nous réalisions ensemble ?", "¿Qué sueño o proyecto me gustaría que realizáramos juntos?") },
      { n: 17, q: P("Qu'est-ce que j'aimerais que tu comprennes davantage concernant mes ambitions ?", "¿Qué me gustaría que entendieras mejor sobre mis ambiciones?") },
    ],
  },
  {
    id: "p4",
    title: P("Partie 4 — Ce que j'aime chez toi", "Parte 4 — Lo que me gusta de ti"),
    note: P("« Fondness & Admiration » : affection, gratitude et admiration comme piliers de la relation.", "«Fondness & Admiration»: afecto, gratitud y admiración como pilares de la relación."),
    questions: [
      { n: 18, q: P("Quelle qualité est-ce que j'admire le plus chez toi ?", "¿Qué cualidad admiro más en ti?") },
      { n: 19, q: P("Quelle qualité chez toi est-ce que je pense particulièrement importante ?", "¿Qué cualidad tuya considero especialmente importante?") },
      { n: 20, q: P("Quel comportement de ta part me touche particulièrement ?", "¿Qué comportamiento tuyo me conmueve especialmente?") },
      { n: 21, q: P("Qu'est-ce que tu fais que je prends peut-être trop souvent pour acquis ?", "¿Qué haces que quizás doy por sentado demasiado a menudo?") },
      { n: 22, q: P("Quelle qualité de toi ai-je probablement davantage appréciée au début de notre relation ?", "¿Qué cualidad tuya probablemente aprecié más al inicio de nuestra relación?") },
      { n: 23, q: P("Quelle qualité chez toi est-ce que j'apprécie aujourd'hui davantage qu'au début ?", "¿Qué cualidad tuya aprecio hoy más que al principio?") },
    ],
  },
  {
    id: "p5",
    title: P("Partie 5 — Comment je me sens aimé(e)", "Parte 5 — Cómo me siento amado/a"),
    questions: [
      { n: 24, q: P("Si tu voulais me faire sentir aimé(e) aujourd'hui, que devrais-tu faire ?", "Si quisieras hacerme sentir amado/a hoy, ¿qué deberías hacer?") },
      {
        n: 25, type: "table",
        q: P("Parmi ces comportements, lesquels sont les plus importants pour moi ? (note sur 10)", "Entre estos comportamientos, ¿cuáles son los más importantes para mí? (nota sobre 10)"),
        rows: P(
          ["Me consacrer du temps", "M'écouter", "Me rassurer", "Me prendre dans tes bras", "Me valoriser", "M'aider concrètement", "Faire une attention", "T'intéresser à ma journée", "Me remercier", "Faire des projets avec moi", "Revenir vers moi après un conflit"],
          ["Dedicarme tiempo", "Escucharme", "Tranquilizarme", "Abrazarme", "Valorarme", "Ayudarme concretamente", "Tener un detalle", "Interesarte por mi día", "Agradecerme", "Hacer planes conmigo", "Volver hacia mí tras un conflicto"]
        ),
      },
    ],
  },
  {
    id: "p6",
    title: P("Partie 6 — Mes petites « demandes de connexion »", "Parte 6 — Mis pequeñas «peticiones de conexión»"),
    note: P("Chez Gottman, les « bids » sont des tentatives de connexion : attention, soutien, affection, partage.", "En Gottman, los «bids» son intentos de conexión: atención, apoyo, afecto, compartir."),
    questions: [
      { n: 26, q: P("Comment est-ce que je cherche généralement ton attention ?", "¿Cómo busco generalmente tu atención?") },
      {
        n: 27, type: "choice",
        q: P("Quand je te raconte quelque chose d'apparemment banal, qu'est-ce que je cherche souvent ?", "Cuando te cuento algo aparentemente banal, ¿qué busco a menudo?"),
        options: P(
          ["simplement partager", "être écouté(e)", "être rassuré(e)", "recevoir de l'attention", "avoir ton avis", "être valorisé(e)", "rire avec toi", "créer de la proximité", "autre"],
          ["simplemente compartir", "ser escuchado/a", "que me tranquilicen", "recibir atención", "tener tu opinión", "ser valorado/a", "reír contigo", "crear cercanía", "otro"]
        ),
      },
      { n: 28, q: P("Quel est probablement mon « bid » le plus fréquent ?", "¿Cuál es probablemente mi «bid» más frecuente?") },
      { n: 29, q: P("Comment est-ce que tu penses généralement y répondre ?", "¿Cómo crees que sueles responder a ello?") },
      { n: 30, q: P("Comment est-ce que je vis cette réponse ?", "¿Cómo vivo esa respuesta?") },
    ],
  },
  {
    id: "p7",
    title: P("Partie 7 — Quand je vais mal", "Parte 7 — Cuando estoy mal"),
    questions: [
      { n: 31, q: P("Lorsque je suis stressé(e), qu'est-ce que j'attends spontanément de toi ?", "Cuando estoy estresado/a, ¿qué espero espontáneamente de ti?") },
      { n: 32, q: P("Lorsque je suis triste, qu'est-ce qui m'aide réellement ?", "Cuando estoy triste, ¿qué me ayuda de verdad?") },
      { n: 33, q: P("Lorsque je suis en colère, qu'est-ce qui m'aide à revenir au calme ?", "Cuando estoy enfadado/a, ¿qué me ayuda a calmarme?") },
      { n: 34, q: P("Lorsque je doute de moi, qu'est-ce que j'aimerais entendre de toi ?", "Cuando dudo de mí, ¿qué me gustaría oír de ti?") },
      { n: 35, q: P("Lorsque je suis fatigué(e), qu'est-ce que j'aimerais que tu comprennes ?", "Cuando estoy cansado/a, ¿qué me gustaría que entendieras?") },
    ],
  },
  {
    id: "p8",
    title: P("Partie 8 — Ce qui peut me blesser", "Parte 8 — Lo que puede herirme"),
    questions: [
      { n: 36, q: P("Quelle attitude de ta part peut particulièrement me blesser ?", "¿Qué actitud tuya puede herirme especialmente?") },
      { n: 37, q: P("Dans quelles situations ai-je tendance à me sentir rejeté(e) ?", "¿En qué situaciones tiendo a sentirme rechazado/a?") },
      { n: 38, q: P("Quelle parole peut avoir sur moi beaucoup plus d'impact que tu ne l'imagines ?", "¿Qué palabra puede tener en mí mucho más impacto del que imaginas?") },
      { n: 39, q: P("Quelle situation peut me faire penser : « Je ne compte pas suffisamment pour toi » ?", "¿Qué situación puede hacerme pensar: «No cuento lo suficiente para ti»?") },
    ],
  },
  {
    id: "p9",
    title: P("Partie 9 — Nos conflits", "Parte 9 — Nuestros conflictos"),
    questions: [
      { n: 40, q: P("Lorsque nous nous disputons, quelle est ma peur principale ?", "Cuando discutimos, ¿cuál es mi miedo principal?") },
      { n: 41, q: P("Lorsque je me ferme / m'énerve / insiste / m'éloigne, qu'est-ce que je cherche réellement ?", "Cuando me cierro / me enfado / insisto / me alejo, ¿qué busco realmente?") },
      { n: 42, q: P("Qu'est-ce qui me permet le plus facilement de revenir vers toi ?", "¿Qué me permite más fácilmente volver hacia ti?") },
      { n: 43, q: P("Quelle tentative de réparation fonctionne particulièrement bien avec moi ?", "¿Qué intento de reparación funciona especialmente bien conmigo?") },
      { n: 44, q: P("Quelle tentative de réparation échoue généralement avec moi ?", "¿Qué intento de reparación suele fracasar conmigo?") },
    ],
  },
  {
    id: "p10",
    title: P("Partie 10 — Est-ce que je vois aussi le positif ?", "Parte 10 — ¿Veo también lo positivo?"),
    note: P("« Positive Perspective » : garder une lecture positive et éviter d'attribuer trop vite une intention négative.", "«Positive Perspective»: mantener una lectura positiva y evitar atribuir demasiado rápido una intención negativa."),
    questions: [
      { n: 45, q: P("Lorsque tu fais quelque chose qui m'agace, quelle intention positive pourrais-je envisager ?", "Cuando haces algo que me molesta, ¿qué intención positiva podría considerar?") },
      { n: 46, q: P("Quelle qualité chez toi peut expliquer certains de tes comportements que je critique ?", "¿Qué cualidad tuya puede explicar algunos comportamientos que critico?") },
      { n: 47, q: P("Quelle différence entre nous pourrais-je apprendre à accepter plutôt qu'à combattre ?", "¿Qué diferencia entre nosotros podría aprender a aceptar en vez de combatir?") },
    ],
  },
  {
    id: "p11",
    title: P("Partie 11 — Nos petits rituels", "Parte 11 — Nuestros pequeños rituales"),
    note: P("Les rituels de connexion sont des comportements réguliers qui structurent la connexion du couple.", "Los rituales de conexión son comportamientos regulares que estructuran la conexión de la pareja."),
    questions: [
      { n: 48, q: P("Quel est notre rituel de couple préféré ?", "¿Cuál es nuestro ritual de pareja preferido?") },
      { n: 49, q: P("Quel petit moment quotidien nous rapproche ?", "¿Qué pequeño momento cotidiano nos acerca?") },
      { n: 50, q: P("Quel rituel avons-nous perdu ?", "¿Qué ritual hemos perdido?") },
      { n: 51, q: P("Quel nouveau rituel aimerais-je créer ?", "¿Qué nuevo ritual me gustaría crear?") },
    ],
  },
];

// Question bonus (non comptée dans le score)
export const CONNAIS_BONUS = {
  q: P(
    "Si je pouvais offrir une seule chose à mon/ma partenaire cette semaine pour qu'il/elle se sente profondément aimé(e), qu'est-ce que je choisirais ?",
    "Si pudiera ofrecer una sola cosa a mi pareja esta semana para que se sienta profundamente amado/a, ¿qué elegiría?"
  ),
};

export const CONNAIS_DISCOVERY = [
  { key: "d1", label: P("Une chose que j'ai découverte sur toi", "Algo que he descubierto sobre ti") },
  { key: "d2", label: P("Une chose que j'avais mal comprise", "Algo que había entendido mal") },
  { key: "d3", label: P("Une chose que j'ai envie de mieux connaître", "Algo que quiero conocer mejor") },
  { key: "d4", label: P("Une chose que je vais davantage remarquer chez toi", "Algo que voy a notar más en ti") },
  { key: "d5", label: P("Une chose que je peux faire cette semaine pour me tourner davantage vers toi", "Algo que puedo hacer esta semana para volverme más hacia ti") },
];

export const CONNAIS_APPORTER = [
  { key: "a1", label: P("La réponse qui vous a le plus surpris(e)", "La respuesta que más te sorprendió") },
  { key: "a2", label: P("L'écart qui vous a le plus appris quelque chose", "La diferencia que más te enseñó algo") },
  { key: "a3", label: P("La chose que vous avez davantage appréciée chez votre partenaire", "Lo que más apreciaste de tu pareja") },
  { key: "a4", label: P("Le point que vous aimeriez travailler en séance", "El punto que te gustaría trabajar en sesión") },
];

export const CONNAIS_T = {
  fr: {
    allModules: "← Tous les modules",
    welcomeTitle: "Est-ce que je te connais vraiment ?",
    subtitle: "Un exercice de découverte du couple inspiré des travaux de Gottman · à réaliser ensemble, hors séance",
    start: "Commencer",
    rulesTitle: "Comment jouer ?",
    rules: [
      "Étape 1 — Je devine pour toi : chacun répond à la place de l'autre, sans lui demander.",
      "Étape 2 — Je réponds pour moi : chacun donne ensuite sa propre réponse.",
      "Étape 3 — On compare : ✓ je t'avais bien compris · ~ j'étais proche · ! je me suis trompé(e).",
      "Étape 4 — On explore : non pas « qui a raison ? » mais « qu'est-ce que j'apprends sur toi ? ».",
    ],
    rule1Title: "Règle n°1 — Ne pas tricher !",
    rule1Text: "Quand je réponds pour mon/ma partenaire, je ne lui demande pas la réponse : je fais une hypothèse à partir de ce que je connais de lui/elle. L'objectif est de mesurer la qualité de notre « carte » de l'autre.",
    prev: "Précédent",
    next: "Suivant",
    modeTitle: "Comment souhaitez-vous procéder ?",
    modeSingle: "Sur cet appareil",
    modeSingleDesc: "Vous remplissez chacun votre feuille à tour de rôle, puis vous comparez ensemble.",
    modeTwo: "Chacun son téléphone",
    modeTwoDesc: "Reliez vos deux feuilles par un code de séance. Chacun répond de son côté.",
    setupTitle: "Qui participe ?",
    partner1: "Partenaire 1",
    partner2: "Partenaire 2",
    partner1Ph: "Prénom du partenaire 1",
    partner2Ph: "Prénom du partenaire 2",
    setupStart: "Commencer avec le partenaire 1",
    sheetOf: "Feuille de",
    sheetHint: (o) => `Devinez la réponse de ${o}, puis notez la vôtre. Ne demandez pas : faites une hypothèse.`,
    guessLabel: (o) => `Ce que je pense que ${o} répondrait`,
    realityLabel: "Ma vraie réponse",
    guessPh: "Votre supposition…",
    realityPh: "Votre réponse…",
    optionsHint: "Repères :",
    tableGuess: "Ce que je pense",
    tableReality: "Ma réponse",
    toPartner2: "Au tour du partenaire 2",
    validateSheet: "Valider ma feuille",
    seeCompare: "Voir la comparaison",
    handoffTitle: (n) => `C'est au tour de ${n}`,
    handoffText: (n) => `Passez l'appareil à ${n}. Les réponses du premier partenaire restent cachées jusqu'à la comparaison.`,
    handoffBtn: (n) => `Je suis ${n}, commencer`,
    createTitle: "Créer une séance",
    createDesc: "Vous obtiendrez un code à partager avec votre partenaire.",
    joinTitle: "Rejoindre avec un code",
    joinDesc: "Votre partenaire a créé une séance et vous a transmis un code.",
    codeLabel: "Code de séance",
    codePh: "Ex. K7M2P9",
    yourName: "Votre prénom",
    genCode: "Générer le code",
    join: "Rejoindre",
    yourCode: "Votre code de séance",
    shareCode: "Partagez ce code — ou le QR code — pour que votre partenaire rejoigne la séance.",
    copyCode: "Copier le code",
    codeCopied: "Code copié",
    fillSheet: "Remplir ma feuille",
    waitTitle: "Votre feuille est enregistrée",
    waitText: "En attente que votre partenaire termine. La comparaison s'ouvrira automatiquement.",
    you: "Vous",
    done: "✓ terminé",
    partner: "Partenaire",
    inProgress: "en cours…",
    compareTitle: "On compare",
    compareText: "Pour chaque question, comparez la supposition et la réalité, puis marquez l'écart. Cherchez ce que vous apprenez l'un de l'autre.",
    guessedBy: (o) => `Ce que ${o} avait deviné`,
    realityOf: (s) => `Réalité de ${s}`,
    markGood: "✓ Bien deviné",
    markClose: "~ Proche",
    markWrong: "! Différent",
    scoreTitle: "Notre score de curiosité",
    scoreNote: "Ce n'est pas un score de qualité du couple. Un score faible signifie simplement : « nous avons encore des choses à découvrir l'un de l'autre. » Et c'est tout l'intérêt de l'exercice.",
    scoreOf: (n) => `Score de ${n}`,
    readingTitle: "Comment lire ce bilan",
    resumeTitle: "Reprendre une séance",
    resumeDesc: "Vous avez déjà répondu tous les deux ? Entrez votre code pour retrouver la comparaison.",
    resumeCta: "Retrouver la comparaison",
    resumeNotReady: "Vos deux feuilles ne sont pas encore complètes.",
    bonusTitle: "La question bonus",
    discoveryTitle: "Notre découverte",
    challengeTitle: "Notre micro-défi de la semaine",
    challengeAction: "Cette semaine, nous allons :",
    challengeWho: "Qui commence ?",
    whoMe: "Moi",
    whoYou: "Toi",
    whoBoth: "Tous les deux",
    challengeWhen: "Quand ?",
    challengeHow: "Comment saurons-nous que nous l'avons fait ?",
    endPhraseTitle: "La phrase de fin",
    endPhrase: "« Ce que j'aimerais que tu n'oublies jamais sur moi, c'est que… »",
    apporterTitle: "À apporter à la prochaine séance",
    apporterIntro: "Ne cherchez pas à tout analyser. Apportez simplement :",
    answerPh: "Votre réponse…",
    exportPdf: "Exporter en PDF",
    restart: "Recommencer",
    createFail: "Impossible de créer la séance",
    enterValidCode: "Entrez un code valide",
    codeNotFound: "Code introuvable",
    joinError: "Erreur de connexion à la séance",
    submitFail: "Échec de l'enregistrement",
  },
  es: {
    allModules: "← Todos los módulos",
    welcomeTitle: "¿Te conozco de verdad?",
    subtitle: "Un ejercicio de descubrimiento en pareja inspirado en los trabajos de Gottman · para hacer juntos, fuera de sesión",
    start: "Empezar",
    rulesTitle: "¿Cómo se juega?",
    rules: [
      "Paso 1 — Adivino por ti: cada uno responde en lugar del otro, sin preguntarle.",
      "Paso 2 — Respondo por mí: cada uno da luego su propia respuesta.",
      "Paso 3 — Comparamos: ✓ te había entendido bien · ~ estuve cerca · ! me equivoqué.",
      "Paso 4 — Exploramos: no «¿quién tiene razón?» sino «¿qué aprendo de ti?».",
    ],
    rule1Title: "Regla n°1 — ¡No hacer trampa!",
    rule1Text: "Cuando respondo por mi pareja, no le pregunto la respuesta: hago una hipótesis a partir de lo que conozco de él/ella. El objetivo es medir la calidad de nuestro «mapa» del otro.",
    prev: "Anterior",
    next: "Siguiente",
    modeTitle: "¿Cómo desean proceder?",
    modeSingle: "En este dispositivo",
    modeSingleDesc: "Cada uno rellena su hoja por turnos y luego comparan juntos.",
    modeTwo: "Cada uno su teléfono",
    modeTwoDesc: "Conecten sus dos hojas con un código de sesión. Cada uno responde por su lado.",
    setupTitle: "¿Quién participa?",
    partner1: "Pareja 1",
    partner2: "Pareja 2",
    partner1Ph: "Nombre de la pareja 1",
    partner2Ph: "Nombre de la pareja 2",
    setupStart: "Empezar con la pareja 1",
    sheetOf: "Hoja de",
    sheetHint: (o) => `Adivine la respuesta de ${o} y luego anote la suya. No pregunte: haga una hipótesis.`,
    guessLabel: (o) => `Lo que creo que ${o} respondería`,
    realityLabel: "Mi respuesta real",
    guessPh: "Su suposición…",
    realityPh: "Su respuesta…",
    optionsHint: "Referencias:",
    tableGuess: "Lo que creo",
    tableReality: "Mi respuesta",
    toPartner2: "Turno de la pareja 2",
    validateSheet: "Validar mi hoja",
    seeCompare: "Ver la comparación",
    handoffTitle: (n) => `Es el turno de ${n}`,
    handoffText: (n) => `Pase el dispositivo a ${n}. Las respuestas de la primera persona permanecen ocultas hasta la comparación.`,
    handoffBtn: (n) => `Soy ${n}, empezar`,
    createTitle: "Crear una sesión",
    createDesc: "Obtendrá un código para compartir con su pareja.",
    joinTitle: "Unirse con un código",
    joinDesc: "Su pareja creó una sesión y le transmitió un código.",
    codeLabel: "Código de sesión",
    codePh: "Ej. K7M2P9",
    yourName: "Su nombre",
    genCode: "Generar el código",
    join: "Unirse",
    yourCode: "Su código de sesión",
    shareCode: "Comparta este código — o el código QR — para que su pareja se una a la sesión.",
    copyCode: "Copiar el código",
    codeCopied: "Código copiado",
    fillSheet: "Rellenar mi hoja",
    waitTitle: "Su hoja está guardada",
    waitText: "Esperando a que su pareja termine. La comparación se abrirá automáticamente.",
    you: "Usted",
    done: "✓ terminado",
    partner: "Pareja",
    inProgress: "en curso…",
    compareTitle: "Comparamos",
    compareText: "Para cada pregunta, comparen la suposición y la realidad, y marquen la diferencia. Busquen lo que aprenden el uno del otro.",
    guessedBy: (o) => `Lo que ${o} había adivinado`,
    realityOf: (s) => `Realidad de ${s}`,
    markGood: "✓ Bien adivinado",
    markClose: "~ Cerca",
    markWrong: "! Diferente",
    scoreTitle: "Nuestra puntuación de curiosidad",
    scoreNote: "No es una puntuación de la calidad de la pareja. Una puntuación baja significa simplemente: «aún tenemos cosas por descubrir el uno del otro». Y ese es el interés del ejercicio.",
    scoreOf: (n) => `Puntuación de ${n}`,
    readingTitle: "Cómo leer este balance",
    resumeTitle: "Retomar una sesión",
    resumeDesc: "¿Ya han respondido los dos? Introduzcan su código para recuperar la comparación.",
    resumeCta: "Recuperar la comparación",
    resumeNotReady: "Vuestras dos hojas aún no están completas.",
    bonusTitle: "La pregunta extra",
    discoveryTitle: "Nuestro descubrimiento",
    challengeTitle: "Nuestro micro-reto de la semana",
    challengeAction: "Esta semana, vamos a:",
    challengeWho: "¿Quién empieza?",
    whoMe: "Yo",
    whoYou: "Tú",
    whoBoth: "Los dos",
    challengeWhen: "¿Cuándo?",
    challengeHow: "¿Cómo sabremos que lo hemos hecho?",
    endPhraseTitle: "La frase final",
    endPhrase: "«Lo que me gustaría que nunca olvidaras de mí es que…»",
    apporterTitle: "Para llevar a la próxima sesión",
    apporterIntro: "No intenten analizarlo todo. Lleven simplemente:",
    answerPh: "Su respuesta…",
    exportPdf: "Exportar en PDF",
    restart: "Volver a empezar",
    createFail: "No se puede crear la sesión",
    enterValidCode: "Introduzca un código válido",
    codeNotFound: "Código no encontrado",
    joinError: "Error de conexión a la sesión",
    submitFail: "Error al guardar",
  },
};

export const CONNAIS_QUESTIONS = CONNAIS_PARTS.flatMap((p) => p.questions);
export const CONNAIS_MAX = CONNAIS_QUESTIONS.length * 2; // /102

// Bilan de curiosité guidé (2-3 phrases, sans jugement) selon les scores.
export function curiosityReading(scoreA, scoreB, max, lang) {
  const avg = (scoreA + scoreB) / 2;
  const pct = max ? avg / max : 0;
  const diffPct = max ? Math.abs(scoreA - scoreB) / max : 0;
  const S = {
    fr: {
      frame: "Ce bilan n'évalue ni votre amour ni la solidité de votre couple : il mesure seulement à quel point votre « carte » de l'autre est à jour aujourd'hui.",
      high: "Vos réponses montrent une belle connaissance mutuelle. Continuez à vous poser ce type de questions, car chacun évolue avec le temps.",
      mid: "Vos réponses révèlent une bonne base et quelques zones encore à explorer : ce sont justement de précieuses occasions de conversation.",
      low: "Des scores plus bas ne signifient pas que vous vous connaissez mal, mais qu'il reste de belles découvertes à faire — c'est une invitation, pas un reproche.",
      diff: "L'écart entre vos deux scores est normal : celui qui a le plus deviné n'aime pas « mieux », il a peut-être simplement une carte plus récente.",
      focus: "Regardez surtout les questions marquées « ! » : chaque écart est une information à explorer ensemble, avec curiosité plutôt qu'avec reproche.",
    },
    es: {
      frame: "Este balance no evalúa vuestro amor ni la solidez de vuestra pareja: solo mide hasta qué punto vuestro «mapa» del otro está actualizado hoy.",
      high: "Vuestras respuestas muestran un buen conocimiento mutuo. Seguid haciéndoos este tipo de preguntas, porque cada uno evoluciona con el tiempo.",
      mid: "Vuestras respuestas revelan una buena base y algunas zonas aún por explorar: son ocasiones valiosas de conversación.",
      low: "Una puntuación más baja no significa que os conozcáis mal, sino que quedan bonitos descubrimientos por hacer: es una invitación, no un reproche.",
      diff: "La diferencia entre vuestras dos puntuaciones es normal: quien ha adivinado más no ama «mejor», quizás simplemente tiene un mapa más reciente.",
      focus: "Fijaos sobre todo en las preguntas marcadas con «!»: cada diferencia es información para explorar juntos, con curiosidad más que con reproche.",
    },
  };
  const s = S[lang] || S.fr;
  const out = [s.frame];
  out.push(pct >= 0.66 ? s.high : pct >= 0.33 ? s.mid : s.low);
  out.push(diffPct >= 0.2 ? s.diff : s.focus);
  return out;
}
